import { CONFIG } from '../constants/StyliticsPLPConstant';

export const getHeadingText = ({
  brand, pageType, catSplashId, isBeautyProduct, isHomeProduct,
}) => {
  let header = 'Complete the look'; // old default value 'Wear it With'

  // pdp
  if (pageType?.value === 'pdp' && isBeautyProduct.value) header = 'Pair it with';
  else if (pageType?.value === 'pdp' && isHomeProduct.value) header = 'Complete the room';
  // plp
  else if (pageType?.value === 'plp' && brand.value === 'bcom') {
    header = CONFIG.categories[catSplashId?.value]?.header;
  }

  return header;
};

// eg: (black/black) or (black black) => black-black
export const styliticsParamCleanEx = (s = '', r) => s.split(/[^a-zA-Z0-9]/g).filter((v) => v !== '')
  .join(r);

// Should format for MCOM (ID_color-name) and for BCOM (ID_Color_Name)
export const formatStyliticsItemNumber = ({ productId, name, brand }) => {
  const _name = (brand === 'bcom') ? name.toString() : name.toString().toLowerCase();
  const _replacer = brand === 'bcom' ? '_' : '-';
  return `${productId}${name ? '_' : ''}${styliticsParamCleanEx(_name, _replacer)}`;
};

export const getStyliticsItemNumber = ({
  product, brand, selectedColorName, optionals = {},
}) => {
  const {
    isMasterProduct, isGetAllOutfits, isGetAllOutfitsBySelectedProduct, isConsolidatedPage, isConsolidatedThirdVariant, selectedProductId,
  } = optionals;
  if (!product.value || !brand || !(selectedColorName?.value || isConsolidatedPage?.value || isMasterProduct?.value)) return null;

  const productId = selectedProductId || product.value?.id;
  const colorMap = product.value?.traits?.colors?.colorMap;
  const shouldContainColor = !isMasterProduct?.value && (!isConsolidatedPage?.value || isConsolidatedThirdVariant?.value);

  let itemNumber = String(productId);

  if (shouldContainColor) {
    if (isGetAllOutfits?.value && isConsolidatedThirdVariant?.value) {
      const itemNumbers = [];
      const memberProductIds = Object.keys(product.value?.relationships?.memberProductMap);
      const colors = Object.values(colorMap);
      memberProductIds.forEach((memberId) => {
        colors.forEach((color) => {
          itemNumbers.push(formatStyliticsItemNumber({
            productId: memberId,
            name: color.name,
            brand: brand.value,
          }));
        });
      });
      itemNumber = itemNumbers.join(',');
    } else if (
      (isGetAllOutfits?.value && !isConsolidatedThirdVariant?.value)
        || (isGetAllOutfitsBySelectedProduct?.value && isConsolidatedThirdVariant?.value)
    ) {
      const itemNumbers = [];
      const colors = Object.values(colorMap);
      colors.forEach((color) => {
        itemNumbers.push(formatStyliticsItemNumber({
          productId,
          name: color.name,
          brand: brand.value,
        }));
      });
      itemNumber = itemNumbers.join(',');
    } else {
      itemNumber = formatStyliticsItemNumber({
        productId,
        brand: brand.value,
        name: selectedColorName?.value || '',
      });
    }
  }

  return itemNumber;
};

export const getItemNumberParams = ({
  featureFlags,
  itemNumber,
  productId,
}) => {
  const isMasterOrConsolidated = featureFlags.isMasterProduct || (featureFlags.isConsolidatedPage && !featureFlags.isConsolidatedThirdVariant);
  const params = {
    item_number: (isMasterOrConsolidated ? productId : itemNumber),
    ...(isMasterOrConsolidated && { item_number_type: 'sku' }),
  };
  return params;
};

export const getCustomCtaElement = () => {
  const ctaArrow = document.createElement('div');
  const arrowClasses = ['stylitics-custom-hotspots-cta--arrow-icon', 'swipe-arrow-right', 'margin-left-xxs'];
  ctaArrow.classList.add(...arrowClasses);

  const customCta = document.createElement('div');
  customCta.innerHTML += 'Swap Items';
  const ctaClasses = ['stylitics-custom-hotspots-cta', 'label', 'align-center-middle', 'padding-bottom-xxs', 'padding-top-xxs'];
  customCta.classList.add(...ctaClasses);
  customCta.appendChild(ctaArrow);

  return customCta;
};

// Mount Widget Event (ALL Widget Types) -> Add collage-image data
export const setEmailDataScrapeAttribute = ({ bundle, element }) => {
  element.setAttribute('data-collage-img', bundle.image_url);
};
